<div class="card collapsible-card"
     [ngClass]="overrideStyleClass">
    <div class="header card-header gap-2"
         [ngClass]="{'collapsible': isCollapsible, 'collapsed': collapsed}"
         (click)="toggle()"
         data-test="collapsible-card-header">
        <i *ngIf="handleId"
           class="fal fa-grip-dots-vertical pe-1 gripper"
           [attr.id]="handleId"></i>
        <i *ngIf="iconClass"
           [ngClass]="iconClass"
           class="header-icon flex-shrink-0 show-icon-on-print"
           [adaptTooltip]="iconTooltip"></i>
        <h4 class="m-0 d-flex align-items-baseline me-auto">
            <a *ngIf="linkObject; else noLink"
               class="me-1"
               [routerLink]="linkObject.path"
               [queryParams]="linkObject.queryParams">
                {{name}}<i class="fal fa-angle-right ms-2"></i>
            </a>
            <i *ngIf="info"
               class="ms-1 fal fa-circle-info"
               [adaptTooltip]="info"></i>

            <ng-template #noLink>
                <span class="me-1">{{name}}</span>
            </ng-template>

            <ng-content select="[adapt-collapsible-header-action]"></ng-content>
        </h4>

        <ng-content select="[adapt-collapsible-header-action-right]"></ng-content>
        <i *ngIf="isCollapsible && isExpandable"
           class="fas {{collapsed ? 'fa-chevron-down' : 'fa-chevron-up'}}"></i>
    </div>
    <div *ngIf="isExpandable"
         [collapse]="collapsed"
         (collapsed)="animationCompleted($event)"
         (expanded)="animationCompleted($event)"
         [isAnimated]="true">
        <div class="card-body element-body">
            <dx-scroll-view *ngIf="useScrollView; else content"
                            [scrollByContent]="true"
                            direction="horizontal">
                <div class="body">
                    <ng-container *ngTemplateOutlet="content"></ng-container>
                </div>
            </dx-scroll-view>
        </div>
    </div>
</div>

<ng-template #content><ng-content></ng-content></ng-template>
